
import { CombeniaAttribute } from "./CombeniaAttribute";

export class CombeniaCriteria {

  public attributes?: Array<CombeniaAttribute>;
  public parentId?: number;
  public types?: Array<string>;
  public flavour?: string;
  public query?: string;
  public order?:{name:string, isDescending?:boolean, direction?:string}

}